/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePauseIcon16Solid = forwardRef('MediaUiCirclePauseIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM5 5a.5.5 0 0 1 .5-.5h1A.5.5 0 0 1 7 5v6a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 5 11V5Zm4.5-.5A.5.5 0 0 0 9 5v6a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5h-1Z" })));
});
